import React from 'react'
import { Container, Image } from 'react-bootstrap'
import logo from '../../assets/thinkfirst.svg'
import { useTranslation } from 'react-i18next';

const ComingSoon = () => {
   const { t } = useTranslation();
  return (
    <Container className='d-flex align-items-center justify-content-center flex-column gap-3 h-100'>
    <Image src={logo} width={300} />
   <div className='text-center'>
   <h4>{t("COMING SOON!")}</h4>
   <h4>{t("WORK IN PROGRESS")}</h4>
   </div>
    </Container>
  )
}

export default ComingSoon